const { adBlockerUsage } = require('../ga4/adBlockerUsage');
const { customerId } = require('../ga4/customerId');
const { dealerId, gaClientId, as24VisitorId, waitTillGA4PageView } = require('../ga4/eventParameters');
const { ga4Market } = require('../ga4/market');
const { loginStatus } = require('../ga4/loginStatus');

const trackGA4PageViewEvent = (eventData, dataLayerVariables) => {
    setTimeout(() => {
        window.dataLayer = window.dataLayer || [];

        // Read adBlockerStatus value from sessionStorage. For first pageView in every session, it will be "undefined"
        // This approach is taken to keep trackPageview() synchronous.
        const adBlockerStatus = sessionStorage.getItem('adBlockerStatus');
        if (adBlockerStatus === null)
            adBlockerUsage(window)
                .then((statusValue) => sessionStorage.setItem('adBlockerStatus', statusValue))
                .catch((err) => console.error("trackGA4PageViewEvent: Couldn't get adBlockerStatus", err));

        if (dataLayerVariables) {
            window.dataLayer.push(dataLayerVariables);
        }

        const dealerIdValue = dealerId();

        window.dataLayer.push({
            event_name: 'page_view',
            event_type: 'page_load',
            market: ga4Market(),
            dealer_id: dealerIdValue,
            ga4_client_id: gaClientId(),
            as24_visitor_id: as24VisitorId(),
            login_status: loginStatus(),
            adblocker_usage: adBlockerStatus,
            customer_id: customerId(),
            content_id: eventData ? eventData.content_id : 'all',
            content_group: eventData ? eventData.content_group : undefined,
            page_title: eventData ? eventData.page_title : undefined,
            content_type: eventData ? eventData.content_type : undefined,
        });

        window.dataLayer.push({ event: 'page_view' });
    }, 0);
};

const trackGA4Event = (event, otherData) => {
    if (!event || event.name.indexOf('_') === -1)
        throw new Error('Event name must follow naming convention: {feature}_{action}');
    setTimeout(() => {
        window.dataLayer = window.dataLayer || [];
        // Format: undefined | 'source=search_form;content=cars'
        const eventDetails = !event.details
            ? undefined
            : Object.entries(event.details)
                  .map(([key, value]) => `${key}=${value}`)
                  .join(';');

        waitTillGA4PageView(() => {
            if (otherData) {
                window.dataLayer.push(otherData);
            }

            window.dataLayer.push({
                event: 'ga4_event',
                event_name: event.name,
                event_type: event.type,
                event_details: eventDetails,
                event_category: event.category,
                event_action: event.action,
                event_label: event.label,
            });
        });
    }, 0);
};

module.exports = {
    trackGA4PageViewEvent: trackGA4PageViewEvent,
    trackGA4Event: trackGA4Event
};



// WEBPACK FOOTER //
// ./src/ga4/tracking.js